const seeds = {
  "title": "Mount Kelvin Cloud API",
  "description": "<div style=\"font-family: monospace; font-weight: 300; padding-bottom: 16px;\">[ Server URL: <a>https://api.mountkelvincloud.com</a> ]</div>\n\n<div style=\"padding: 8px; margin-bottom: 2em; border: 1px solid #d9534f; border-radius: 8px; font: 14px sans-serif; display: flex; align-items: center;\">\n  <div style=\"font: bold 32px sans-serif; margin-right: 8px; width: 30px; text-align: center; color: #d9534f;\">!</div>\n  <p><b>Notice:</b> Aspects of this API are subject to changes. Be prepared to make updates as the API evolves.</p>\n</div>\n\nAPI keys can be created from the Mount Kelvin Configuration UI or requested from the Mount Kelvin team.\n\nThe API key from the UI is supplied with each request in the Authorization header as detailed by the documentation for each endpoint.",
  "groups": [
    {
      "title": "Site",
      "permalink": "g~site",
      "description": "Site is the core object for any Mount Kelvin installation. A site is a single hotel property, which includes one or more floors, which include one or more spaces which in turn may include one or more rooms.",
      "resources": [
        {
          "title": "Site collection",
          "permalink": "r~site~site~collection",
          "description": "",
          "transitions": [
            {
              "title": "Get all sites",
              "permalink": "t~site~site~collection~get~v4~sites",
              "method": "GET",
              "path": "/v4/sites",
              "meta": {
                "resource": {
                  "title": "Site collection",
                  "permalink": "r~site~site~collection"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            },
            {
              "title": "Create a site",
              "permalink": "t~site~site~collection~post~v4~sites",
              "method": "POST",
              "path": "/v4/sites",
              "meta": {
                "resource": {
                  "title": "Site collection",
                  "permalink": "r~site~site~collection"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            }
          ]
        },
        {
          "title": "Single site",
          "permalink": "r~site~single~site",
          "description": "",
          "transitions": [
            {
              "title": "View a site detail",
              "permalink": "t~site~single~site~get~v4~sites~siteid",
              "method": "GET",
              "path": "/v4/sites/{siteId}",
              "meta": {
                "resource": {
                  "title": "Single site",
                  "permalink": "r~site~single~site"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            },
            {
              "title": "Edit a site (PUT)",
              "permalink": "t~site~single~site~put~v4~sites~siteid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}",
              "meta": {
                "resource": {
                  "title": "Single site",
                  "permalink": "r~site~single~site"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            },
            {
              "title": "Edit a site (PATCH)",
              "permalink": "t~site~single~site~patch~v4~sites~siteid",
              "method": "PATCH",
              "path": "/v4/sites/{siteId}",
              "meta": {
                "resource": {
                  "title": "Single site",
                  "permalink": "r~site~single~site"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            },
            {
              "title": "Delete a site",
              "permalink": "t~site~single~site~delete~v4~sites~siteid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}",
              "meta": {
                "resource": {
                  "title": "Single site",
                  "permalink": "r~site~single~site"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            }
          ]
        },
        {
          "title": "Sensor data",
          "permalink": "r~site~sensor~data",
          "description": "All objects' related events are stored as inputs. For example, motion sensor do generate only motion inputs. For switches\nthere will be inputs for every button press.",
          "transitions": [
            {
              "title": "Get sensor history",
              "permalink": "t~site~sensor~data~get~v4~sites~siteid~inputs~type~type~and~start~start~and~end~end",
              "method": "GET",
              "path": "/v4/sites/{siteId}/inputs?type={type}&start={start}&end={end}",
              "meta": {
                "resource": {
                  "title": "Sensor data",
                  "permalink": "r~site~sensor~data"
                },
                "group": {
                  "title": "Site",
                  "permalink": "g~site"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Floor",
      "permalink": "g~floor",
      "description": "The level of a site(building) is known as floor. A site may have only one or multiple floors.",
      "resources": [
        {
          "title": "Floor collection",
          "permalink": "r~floor~floor~collection",
          "description": "Create a new floor.\n\nWe have added the query URI template parameter - `sourceFloorId`. This parameter is\nused for copying an existing floor and it's spaces. \nThe new floor will have same number of spaces of that existing one.",
          "transitions": [
            {
              "title": "Create a new floor",
              "permalink": "t~floor~floor~collection~post~v4~sites~siteid~floors",
              "method": "POST",
              "path": "/v4/sites/{siteId}/floors",
              "meta": {
                "resource": {
                  "title": "Floor collection",
                  "permalink": "r~floor~floor~collection"
                },
                "group": {
                  "title": "Floor",
                  "permalink": "g~floor"
                }
              }
            }
          ]
        },
        {
          "title": "Single Floor",
          "permalink": "r~floor~single~floor",
          "description": "",
          "transitions": [
            {
              "title": "Edit a floor (PUT)",
              "permalink": "t~floor~single~floor~put~v4~sites~siteid~floors~floorid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}/floors/{floorId}",
              "meta": {
                "resource": {
                  "title": "Single Floor",
                  "permalink": "r~floor~single~floor"
                },
                "group": {
                  "title": "Floor",
                  "permalink": "g~floor"
                }
              }
            },
            {
              "title": "Edit a floor (PATCH)",
              "permalink": "t~floor~single~floor~patch~v4~sites~siteid~floors~floorid",
              "method": "PATCH",
              "path": "/v4/sites/{siteId}/floors/{floorId}",
              "meta": {
                "resource": {
                  "title": "Single Floor",
                  "permalink": "r~floor~single~floor"
                },
                "group": {
                  "title": "Floor",
                  "permalink": "g~floor"
                }
              }
            },
            {
              "title": "Delete a floor",
              "permalink": "t~floor~single~floor~delete~v4~sites~siteid~floors~floorid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/floors/{floorId}",
              "meta": {
                "resource": {
                  "title": "Single Floor",
                  "permalink": "r~floor~single~floor"
                },
                "group": {
                  "title": "Floor",
                  "permalink": "g~floor"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Space",
      "permalink": "g~space",
      "description": "A space is a collection of different types of rooms. In a typical hotel property a space is one hotel room, which in turn may have multiple rooms (eg. a living room and a bathroom). A space object can also be used to group together public spaces in a hotel floor, such as corridors, meeting rooms and lobbies.",
      "resources": [
        {
          "title": "Spaces collection",
          "permalink": "r~space~spaces~collection",
          "description": "Create a new space, by either\n\n+ Creating a blank one\n\n+ Using an existing space as a template or\n\n+ Copying an existing space\n\nIf `template` is provided in the request body, the new space will be linked to another space to be used as it's template.\nIn most hotels, there are usually a few primary room types, with little variance across them.\nThe template feature allows for rapid creation and easy maintenance of identical rooms: changes to the template room will be reflected in other rooms too.\n\nThe template will replicate the specific contents of the space (rooms, scenes and assigned logical devices with it's configuration)\nof the template space to the linked target space and ensure that when changes to the template are made,\nthe changes are reflected in the linked spaces as well. Directly editing (e.g. adding new room, space, logical devices and removing logical devices) a space with a linked template is not possible, without unlinking the space first.\n\nThe URI parameter - `sourceSpaceId` allows making  copies of an existing space. Combination of templating and copying has the following three behaviors:\n\n+ If the space referenced by `sourceSpaceId` owns a template,\nthen the new space will inherit all the room(s), space(s) and logical device(s) (***not physical device***) with the configuration of the `sourceSpaceId` space.\nIn this case, no room, space and logical device can be added to or delete from the new space. Only phsical device can be assigned to  or unassigned from the logical device.\nAs new space inherits all the room(s), space(s) and logical device(s) (***not physical device***) with the configuration of `sourceSpaceId` space by template,\nso any change of room, space and logical device in `sourceSpaceId` space will be available in new space too.\n\n+ If the space referenced by `sourceSpaceId` is using another space as a template,\nthen the new space will inherit all the room(s), space(s) and logical device(s) (***not physical device***) with the configuration of that root space from where `sourceSpaceId` space inherited.\nIn this case, no room, space and logical device can be added to or delete from the new space. Only phsical device can be assigned to  or unassigned from the logical device.\nAs new space inherits all the room(s), space(s) and logical device(s) (***not physical device***) with the configuration of that root space from where `sourceSpaceId` space inherited,\nso any change of room, space and logical device in `sourceSpaceId` space will be available in new space too.\n\n+ If the space referenced by `sourceSpaceId` does not have it's own or inherited `template`,\nthen the new space will only copy the content and device configuration from `sourceSpaceId` space (if it has any content) once.\nAs `sourceSpaceId` does not have any `template`, any content change in `sourceSpaceId` space will not be available in new space.\nIn this case, the new space can be edited, means new rooms, scenes, logical devices can be added to or remove from the new space.",
          "transitions": [
            {
              "title": "Create space",
              "permalink": "t~space~spaces~collection~post~v4~sites~siteid~spaces",
              "method": "POST",
              "path": "/v4/sites/{siteId}/spaces",
              "meta": {
                "resource": {
                  "title": "Spaces collection",
                  "permalink": "r~space~spaces~collection"
                },
                "group": {
                  "title": "Space",
                  "permalink": "g~space"
                }
              }
            }
          ]
        },
        {
          "title": "Single Space",
          "permalink": "r~space~single~space",
          "description": "",
          "transitions": [
            {
              "title": "Edit a space (PUT)",
              "permalink": "t~space~single~space~put~v4~sites~siteid~spaces~spaceid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}/spaces/{spaceId}",
              "meta": {
                "resource": {
                  "title": "Single Space",
                  "permalink": "r~space~single~space"
                },
                "group": {
                  "title": "Space",
                  "permalink": "g~space"
                }
              }
            },
            {
              "title": "Edit a space (PATCH)",
              "permalink": "t~space~single~space~patch~v4~sites~siteid~spaces~spaceid",
              "method": "PATCH",
              "path": "/v4/sites/{siteId}/spaces/{spaceId}",
              "meta": {
                "resource": {
                  "title": "Single Space",
                  "permalink": "r~space~single~space"
                },
                "group": {
                  "title": "Space",
                  "permalink": "g~space"
                }
              }
            },
            {
              "title": "DELETE a space",
              "permalink": "t~space~single~space~delete~v4~sites~siteid~spaces~spaceid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/spaces/{spaceId}",
              "meta": {
                "resource": {
                  "title": "Single Space",
                  "permalink": "r~space~single~space"
                },
                "group": {
                  "title": "Space",
                  "permalink": "g~space"
                }
              }
            }
          ]
        },
        {
          "title": "Resources in a space",
          "permalink": "r~space~resources~in~a~space",
          "description": "",
          "transitions": [
            {
              "title": "Detach resources from space",
              "permalink": "t~space~resources~in~a~space~delete~v4~sites~siteid~spaces~spaceid~resources",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/spaces/{spaceId}/resources",
              "meta": {
                "resource": {
                  "title": "Resources in a space",
                  "permalink": "r~space~resources~in~a~space"
                },
                "group": {
                  "title": "Space",
                  "permalink": "g~space"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Room",
      "permalink": "g~room",
      "description": "A room is a part of a larger space. In typical hotels, a room object will correspond to a living room or a toilet in a hotel room or a meeting room or restaurant in public spaces.",
      "resources": [
        {
          "title": "Room collection",
          "permalink": "r~room~room~collection",
          "description": "",
          "transitions": [
            {
              "title": "Create room",
              "permalink": "t~room~room~collection~post~v4~sites~siteid~rooms",
              "method": "POST",
              "path": "/v4/sites/{siteId}/rooms",
              "meta": {
                "resource": {
                  "title": "Room collection",
                  "permalink": "r~room~room~collection"
                },
                "group": {
                  "title": "Room",
                  "permalink": "g~room"
                }
              }
            }
          ]
        },
        {
          "title": "Single room",
          "permalink": "r~room~single~room",
          "description": "",
          "transitions": [
            {
              "title": "Edit room",
              "permalink": "t~room~single~room~put~v4~sites~siteid~rooms~roomid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}/rooms/{roomId}",
              "meta": {
                "resource": {
                  "title": "Single room",
                  "permalink": "r~room~single~room"
                },
                "group": {
                  "title": "Room",
                  "permalink": "g~room"
                }
              }
            },
            {
              "title": "Delete room",
              "permalink": "t~room~single~room~delete~v4~sites~siteid~rooms~roomid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/rooms/{roomId}",
              "meta": {
                "resource": {
                  "title": "Single room",
                  "permalink": "r~room~single~room"
                },
                "group": {
                  "title": "Room",
                  "permalink": "g~room"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Resource",
      "permalink": "g~resource",
      "description": "A resources is a physical device which are installed in rooms. The available resources types right now are actuator(light), switch, motion sensor and door sensor.",
      "resources": [
        {
          "title": "Resource collection",
          "permalink": "r~resource~resource~collection",
          "description": "Add an physical device",
          "transitions": [
            {
              "title": "Create resource",
              "permalink": "t~resource~resource~collection~post~v4~sites~siteid~resources",
              "method": "POST",
              "path": "/v4/sites/{siteId}/resources",
              "meta": {
                "resource": {
                  "title": "Resource collection",
                  "permalink": "r~resource~resource~collection"
                },
                "group": {
                  "title": "Resource",
                  "permalink": "g~resource"
                }
              }
            }
          ]
        },
        {
          "title": "Single Resource",
          "permalink": "r~resource~single~resource",
          "description": "",
          "transitions": [
            {
              "title": "Update a resource",
              "permalink": "t~resource~single~resource~patch~v4~sites~siteid~resources~resourceid",
              "method": "PATCH",
              "path": "/v4/sites/{siteId}/resources/{resourceId}",
              "meta": {
                "resource": {
                  "title": "Single Resource",
                  "permalink": "r~resource~single~resource"
                },
                "group": {
                  "title": "Resource",
                  "permalink": "g~resource"
                }
              }
            },
            {
              "title": "Delete a resource",
              "permalink": "t~resource~single~resource~delete~v4~sites~siteid~resources~resourceid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/resources/{resourceId}",
              "meta": {
                "resource": {
                  "title": "Single Resource",
                  "permalink": "r~resource~single~resource"
                },
                "group": {
                  "title": "Resource",
                  "permalink": "g~resource"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Scene",
      "permalink": "g~scene",
      "description": "A scene is the state of a light. Effectively, all scenes consist of a list of lights and a corresponding brightness, color and on/off state for each of the objects.\n\nThe scenes are activated either by mapping them to switches or motion sensors or by using the Apply endpoint via the API.",
      "resources": [
        {
          "title": "Scene collection",
          "permalink": "r~scene~scene~collection",
          "description": "",
          "transitions": [
            {
              "title": "Create a scene",
              "permalink": "t~scene~scene~collection~post~v4~sites~siteid~scenes",
              "method": "POST",
              "path": "/v4/sites/{siteId}/scenes",
              "meta": {
                "resource": {
                  "title": "Scene collection",
                  "permalink": "r~scene~scene~collection"
                },
                "group": {
                  "title": "Scene",
                  "permalink": "g~scene"
                }
              }
            }
          ]
        },
        {
          "title": "Single scene",
          "permalink": "r~scene~single~scene",
          "description": "",
          "transitions": [
            {
              "title": "Update scene",
              "permalink": "t~scene~single~scene~put~v4~sites~siteid~scenes~sceneid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}/scenes/{sceneId}",
              "meta": {
                "resource": {
                  "title": "Single scene",
                  "permalink": "r~scene~single~scene"
                },
                "group": {
                  "title": "Scene",
                  "permalink": "g~scene"
                }
              }
            },
            {
              "title": "Delete scene",
              "permalink": "t~scene~single~scene~delete~v4~sites~siteid~scenes~sceneid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/scenes/{sceneId}",
              "meta": {
                "resource": {
                  "title": "Single scene",
                  "permalink": "r~scene~single~scene"
                },
                "group": {
                  "title": "Scene",
                  "permalink": "g~scene"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Object",
      "permalink": "g~object",
      "description": "Object is the relation between a room and the resources (lights, motion sensor or switches) in that room.\nWhen a device is assigned to a room, an object is created. An object tells which resources are assigned to which room, the configurations mean\nwhat task assigned to the device at what stage based on the nature of the device (e.g. if the device is door sensor then what will happen to lights in the room where the door sensor is attached when open and close the door) and others information.",
      "resources": [
        {
          "title": "Create an object",
          "permalink": "r~object~create~an~object",
          "description": "An object will be created while assigning a logical device to a room.\n\n***Note-*** There are four types of logical device. `light`, `switch`, `doorSensor`, `motionSensor`. Each type has some common property in the request body. And other properties are different from each other. So, the request body will have different properties based on the value selected for the property `type`.\nThere are four different request body schema available in the api example.",
          "transitions": [
            {
              "title": "Create object",
              "permalink": "t~object~create~an~object~post~v4~sites~siteid~objects",
              "method": "POST",
              "path": "/v4/sites/{siteId}/objects",
              "meta": {
                "resource": {
                  "title": "Create an object",
                  "permalink": "r~object~create~an~object"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            }
          ]
        },
        {
          "title": "Edit object",
          "permalink": "r~object~edit~object",
          "description": "",
          "transitions": [
            {
              "title": "Edit an object (PUT)",
              "permalink": "t~object~edit~object~put~v4~sites~siteid~objects~objectid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}/objects/{objectId}",
              "meta": {
                "resource": {
                  "title": "Edit object",
                  "permalink": "r~object~edit~object"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            },
            {
              "title": "Edit an object (PATCH)",
              "permalink": "t~object~edit~object~patch~v4~sites~siteid~objects~objectid",
              "method": "PATCH",
              "path": "/v4/sites/{siteId}/objects/{objectId}",
              "meta": {
                "resource": {
                  "title": "Edit object",
                  "permalink": "r~object~edit~object"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            },
            {
              "title": "Delete an object",
              "permalink": "t~object~edit~object~delete~v4~sites~siteid~objects~objectid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/objects/{objectId}",
              "meta": {
                "resource": {
                  "title": "Edit object",
                  "permalink": "r~object~edit~object"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            }
          ]
        },
        {
          "title": "Attach a resource to a object",
          "permalink": "r~object~attach~a~resource~to~a~object",
          "description": "",
          "transitions": [
            {
              "title": "Attach resource",
              "permalink": "t~object~attach~a~resource~to~a~object~put~v4~sites~siteid~objects~objectid~resources~resourceid",
              "method": "PUT",
              "path": "/v4/sites/{siteId}/objects/{objectId}/resources/{resourceId}",
              "meta": {
                "resource": {
                  "title": "Attach a resource to a object",
                  "permalink": "r~object~attach~a~resource~to~a~object"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            },
            {
              "title": "Detach resource from object",
              "permalink": "t~object~attach~a~resource~to~a~object~delete~v4~sites~siteid~objects~objectid~resources~resourceid",
              "method": "DELETE",
              "path": "/v4/sites/{siteId}/objects/{objectId}/resources/{resourceId}",
              "meta": {
                "resource": {
                  "title": "Attach a resource to a object",
                  "permalink": "r~object~attach~a~resource~to~a~object"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            }
          ]
        },
        {
          "title": "Sensor data",
          "permalink": "r~object~sensor~data",
          "description": "All objects' related events are stored as inputs. For example, motion sensor do generate only motion inputs. For switches\nthere will be inputs for every button press.",
          "transitions": [
            {
              "title": "Get sensor history",
              "permalink": "t~object~sensor~data~get~v4~sites~siteid~objects~objectid~inputs~start~start~and~end~end",
              "method": "GET",
              "path": "/v4/sites/{siteId}/objects/{objectId}/inputs?start={start}&end={end}",
              "meta": {
                "resource": {
                  "title": "Sensor data",
                  "permalink": "r~object~sensor~data"
                },
                "group": {
                  "title": "Object",
                  "permalink": "g~object"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Controlling state",
      "permalink": "g~controlling~state",
      "description": "The Apply endpoint can be used to control lights and other devices. There are two key use cases:\n\n* Applying a preset scene (the states and included devices are defined in the pre-created scene)\n\n* Applying an arbitrary state to a group of devices. The state can be applied to a single light, to all lights in a room, to all lights in a space or to all lights attached to a logical device.\n\nFor a scene to be used, a scene must first be created through the Scene API.",
      "resources": [
        {
          "title": "Direct light controls",
          "permalink": "r~controlling~state~direct~light~controls",
          "description": "The state can be applied to a single light, to all lights in a room or to all lights in a space.",
          "transitions": [
            {
              "title": "Control a single light, all lights in a room or iall lights in a spaces",
              "permalink": "t~controlling~state~direct~light~controls~post~v4~sites~siteid~apply",
              "method": "POST",
              "path": "/v4/sites/{siteId}/apply",
              "meta": {
                "resource": {
                  "title": "Direct light controls",
                  "permalink": "r~controlling~state~direct~light~controls"
                },
                "group": {
                  "title": "Controlling state",
                  "permalink": "g~controlling~state"
                }
              }
            }
          ]
        },
        {
          "title": "Direct curtain controls",
          "permalink": "r~controlling~state~direct~curtain~controls",
          "description": "The state can be applied to a single curtain, to all curtains in a room or to all curtains in a space.\n\nCurtains can either be set to open or close state, as the curtain controller is fundamentally a relay, which cannot sense the open or close state of the curtains.",
          "transitions": [
            {
              "title": "Control a single curtain, all curtains in a room or all curtains in a space",
              "permalink": "t~controlling~state~direct~curtain~controls~post~v4~sites~siteid~apply",
              "method": "POST",
              "path": "/v4/sites/{siteId}/apply",
              "meta": {
                "resource": {
                  "title": "Direct curtain controls",
                  "permalink": "r~controlling~state~direct~curtain~controls"
                },
                "group": {
                  "title": "Controlling state",
                  "permalink": "g~controlling~state"
                }
              }
            }
          ]
        },
        {
          "title": "Scene activations",
          "permalink": "r~controlling~state~scene~activations",
          "description": "Activate a preset scene. The states and included devices are defined in the pre-created scene.",
          "transitions": [
            {
              "title": "Set brightness of devices by activating a preset scene",
              "permalink": "t~controlling~state~scene~activations~post~v4~sites~siteid~apply",
              "method": "POST",
              "path": "/v4/sites/{siteId}/apply",
              "meta": {
                "resource": {
                  "title": "Scene activations",
                  "permalink": "r~controlling~state~scene~activations"
                },
                "group": {
                  "title": "Controlling state",
                  "permalink": "g~controlling~state"
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "resources": [],
  "config": {
    "overrides": {},
    "playground": {
      "enabled": false
    },
    "basePath": "/"
  },
  "uuids": {
    "t~site~site~collection~get~v4~sites": "tcXmG7NYpbM9_1ea4FEah",
    "t~site~site~collection~post~v4~sites": "a_1xNQPZgJWCHINGFeb7K",
    "t~site~single~site~get~v4~sites~siteid": "xiSc-yMgQ1-1pg1kWEsXG",
    "t~site~single~site~put~v4~sites~siteid": "p4aDchBRLcLzz53OqMvno",
    "t~site~single~site~patch~v4~sites~siteid": "XYVQGlVTf5Hl1oLaEFqYO",
    "t~site~single~site~delete~v4~sites~siteid": "vjOHnfqDdkOpRh7PLN5GT",
    "t~site~sensor~data~get~v4~sites~siteid~inputs~type~type~and~start~start~and~end~end": "LQ-9rx1ogq8BIWIqdQGMX",
    "t~floor~floor~collection~post~v4~sites~siteid~floors": "tU7kB3OAzIeBG7dYsQWAG",
    "t~floor~single~floor~put~v4~sites~siteid~floors~floorid": "0fTW4DohA0ucw09pW-ZIx",
    "t~floor~single~floor~patch~v4~sites~siteid~floors~floorid": "IQXTbccHZNgIa-UGNHyR1",
    "t~floor~single~floor~delete~v4~sites~siteid~floors~floorid": "6smYS8vNXU_2L6dImmGkY",
    "t~space~spaces~collection~post~v4~sites~siteid~spaces": "lafyRoCjKT72vpqErauIF",
    "t~space~single~space~put~v4~sites~siteid~spaces~spaceid": "FT1q_-2JkJ2Y4qDF9vecP",
    "t~space~single~space~patch~v4~sites~siteid~spaces~spaceid": "3cGcE-SJ94gH_ikuhsmMh",
    "t~space~single~space~delete~v4~sites~siteid~spaces~spaceid": "BOifYQYSIfaMjEoXqNJBi",
    "t~space~resources~in~a~space~delete~v4~sites~siteid~spaces~spaceid~resources": "fl1WDzDEpiXFCmIhg_iw0",
    "t~room~room~collection~post~v4~sites~siteid~rooms": "35cDqj4P2UW1A2Y2vdEIK",
    "t~room~single~room~put~v4~sites~siteid~rooms~roomid": "mJFkpuMTwNaeA4n1NMCzF",
    "t~room~single~room~delete~v4~sites~siteid~rooms~roomid": "imO1BwpS08k3q60uzIGYu",
    "t~resource~resource~collection~post~v4~sites~siteid~resources": "ksbd6is9VlH1vRN4NaMpO",
    "t~resource~single~resource~patch~v4~sites~siteid~resources~resourceid": "iIgv8Xk16Ui9_4pCmN_CQ",
    "t~resource~single~resource~delete~v4~sites~siteid~resources~resourceid": "6d0QcxQ5xsP81jjbEGhjq",
    "t~scene~scene~collection~post~v4~sites~siteid~scenes": "q5DYtrvvHkjPHwG2jC1Bn",
    "t~scene~single~scene~put~v4~sites~siteid~scenes~sceneid": "9m1-r3nJOHqGRz3fqKoxU",
    "t~scene~single~scene~delete~v4~sites~siteid~scenes~sceneid": "eXQdmYPnPrtPUcGqYoJUx",
    "t~object~create~an~object~post~v4~sites~siteid~objects": "SzRdOHLVEME1Xm7YcGnj0",
    "t~object~edit~object~put~v4~sites~siteid~objects~objectid": "lM3n3vpsa_1g-XYjK3T4A",
    "t~object~edit~object~patch~v4~sites~siteid~objects~objectid": "iNcVNtsh706YAhLT0mXor",
    "t~object~edit~object~delete~v4~sites~siteid~objects~objectid": "KC3qGl8mL0DA7JVeGrEcm",
    "t~object~attach~a~resource~to~a~object~put~v4~sites~siteid~objects~objectid~resources~resourceid": "1Lz4560eBViizFW2MGsD2",
    "t~object~attach~a~resource~to~a~object~delete~v4~sites~siteid~objects~objectid~resources~resourceid": "50qhPtT7xw5UFOZbNF-JF",
    "t~object~sensor~data~get~v4~sites~siteid~objects~objectid~inputs~start~start~and~end~end": "fmn3d9qX-YdzfGGu7JDYd",
    "t~controlling~state~direct~light~controls~post~v4~sites~siteid~apply": "3Vp6aQGxHAaUhOEbCOog0",
    "t~controlling~state~direct~curtain~controls~post~v4~sites~siteid~apply": "ABfbhoPObvEiL7_QErFFr",
    "t~controlling~state~scene~activations~post~v4~sites~siteid~apply": "6YIaa1xTRn2CLnwGtE2D0"
  },
  "descriptionToc": []
};
export default seeds;
  